import { useMutation, UseMutationResult } from "react-query"
import Settings from "utils/CarrotConfig"
import CarrotClient from "lib/carrot-api"
import { CarrotPlan } from "types/CarrotPlan"
import ResponseError from "utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

export type JourneyData = {
  primaryJourneyId: number | null
  primaryJourneyStageId: number | null
  secondaryJourneyId: number | null
  secondaryJourneyStageId: number | null
  tertiaryJourneyId: number | null
  tertiaryJourneyStageId: number | null
}

export type Step = {
  url: string
  menuItemId: string
  entryId: string | null
}

export type CreateCarrotPlanRequest = {
  employeeId: number
  carrotPlanSteps: Step[]
  journeyData: JourneyData
}

const submitData = async (carrotPlanRequest: CreateCarrotPlanRequest): Promise<CarrotPlan> => {
  return await client.createCarrotPlan(carrotPlanRequest)
}

export function useCreateCarrotPlan(): UseMutationResult<CarrotPlan, ResponseError, CreateCarrotPlanRequest> {
  return useMutation<CarrotPlan, ResponseError, CreateCarrotPlanRequest>(
    (carrotPlanRequest: CreateCarrotPlanRequest) => submitData(carrotPlanRequest),
    { ...RetryConfig }
  )
}
